const CATEGORY_LIST_URL = "/v1/stock/category/list";
const CATEGORY_SINGLE_URL = "/v1/stock/category/single";
const CATEGORY_ADD_URL = "/v1/stock/category/add";
const CATEGORY_UPDATE_URL = "/v1/stock/category/update";
const CATEGORY_DELETE_URL = "/v1/stock/category/delete";
const CURRENT_STOCK_ACTIONS_URL = "/v1/stock/actions";
const STOCK_LIST_URL = "/v1/stock/list";
const STOCK_ACTION_LIST_URL = "/v1/stock/actions";
const SINGLE_STOCK_URL = '/v1/stock/single';
const SINGLE_STOCK_IMAGE = '/images/stock_images';
const EQUIVALENT_CODE_LIST_URL = '/v1/stock/equivalent-code/list';
const ADD_EQUIVALENT_CODE_URL = '/v1/stock/equivalent-code/add';
const UPDATE_EQUIVALENT_CODE_URL = '/v1/stock/equivalent-code/update';
const ADD_PROPERTY_URL = '/v1/stock/property/add';
const UPDATE_PROPERTY_URL = '/v1/stock/property/update';
const STOCK_SEARCH_URL = "/v1/stock/search-stock";
const STOCK_CODES_LIST_URL = "/v1/stock/codes-list";
const DELETE_STOCK_IMAGE_URL = "/v1/stock/file/delete"

const STOCK_API_URL_LIST = {
    CATEGORY_LIST_URL,
    CATEGORY_SINGLE_URL,
    CATEGORY_ADD_URL,
    CATEGORY_UPDATE_URL,
    CATEGORY_DELETE_URL,
    CURRENT_STOCK_ACTIONS_URL,
    STOCK_LIST_URL,
    STOCK_ACTION_LIST_URL,
    SINGLE_STOCK_URL,
    SINGLE_STOCK_IMAGE,
    ADD_EQUIVALENT_CODE_URL,
    UPDATE_EQUIVALENT_CODE_URL,
    EQUIVALENT_CODE_LIST_URL,
    ADD_PROPERTY_URL,
    UPDATE_PROPERTY_URL,
    STOCK_SEARCH_URL,
    STOCK_CODES_LIST_URL,
    DELETE_STOCK_IMAGE_URL
}

export { STOCK_API_URL_LIST };